import React from "react";
import styled from "@emotion/styled";
import { InfoPagesLayout } from "../../components/layout/info-pages-layout";
import { FormattedMessage } from "react-intl";

export const ContactPage = () => {
    return (
        <InfoPagesLayout title={<FormattedMessage id={"footer.about-us"} />}>
            <p>
                Wir sind ...
            </p>
            <br />
            <br />
            <br />
            <p>
                Die Website blagoom.com wird betrieben von:
            </p>
            <p> Blagoom GbR
                vertretungsberechtigte Gesellschafter: Manuel Walzog, David Schmitd</p>
            <p>Werrastraße 13, 12059 Berlin </p>
            <p>Telefon: </p>
            <p>
                E-Mail: team@blagoom.de </p>
            <p> Steuernummer: xxx</p>
            <p>  Redaktionell Verantwortliche: Manuel Walzog, David Schmidt und Jonas Gebauer
                Werrastraße 13, 12059 Berlin</p>
            <p>
                Link auf die Plattform der EU-Kommission zur Online-Streitbeilegung:
                https://ec.europa.eu/consumers/odr
            </p>
            <p>
                Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und grundsätzlich nicht bereit.
            </p>
            <p>
                Weitere Informationen unter: www.abmahnung.de/os-plattform/
            </p>
        </InfoPagesLayout>
    );
};
